/**
 * bankMatching — Bankumsatz ↔ offener Posten (rein).
 * Ausgang (Betrag < 0) passt nur zu Kreditor-Posten (payable),
 * Eingang (Betrag > 0) nur zu Debitor-Posten (receivable).
 */

export function itemsForTransaction(tx, openItems) {
  const type = Number(tx?.amount) < 0 ? 'payable' : 'receivable';
  return (openItems || []).filter((i) => (i.type || 'receivable') === type);
}

const escapeRe = (s) => s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

/**
 * Steht die Belegnummer als GANZES Wort im Verwendungszweck?
 * Trennzeichen (-, /, Leerzeichen) und führende Nullen dürfen abweichen
 * ("RE 2026 42" = "RE-2026-0042"), aber "RE-1" passt nie zu "RE-10".
 */
export function hasInvoiceToken(purpose, invoiceNo) {
  const text = String(purpose || '');
  const parts = String(invoiceNo || '').split(/[^A-Za-z0-9]+/).filter(Boolean);
  if (!text || parts.length === 0) return false;
  const pattern = parts
    .map((p) => (/^\d+$/.test(p) ? `0*${escapeRe(String(Number(p)))}` : escapeRe(p)))
    .join('[\\s\\-/_.]*');
  return new RegExp(`(^|[^A-Za-z0-9])${pattern}(?![0-9])`, 'i').test(text);
}

/**
 * Sicherer Vorschlag: Betrag exakt UND Belegnummer im Verwendungszweck.
 * Nie nur über den Betrag (zwei gleiche Beträge würden sonst falsch gebucht).
 */
export function suggestMatch(tx, openItems) {
  const amount = Math.abs(Number(tx.amount));
  const candidates = itemsForTransaction(tx, openItems).filter(
    (i) => Math.abs(Number(i.open_amount) - amount) < 0.005
      && i.invoice_no && hasInvoiceToken(tx.purpose, i.invoice_no)
  );
  return candidates.length === 1 ? candidates[0] : null;
}
